const fetcher = (endpoint) => {
  return async () => {
    try {
      const res = await fetch(api.url + endpoint);

      return await res.json();
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getBenefits = fetcher("/benefits");
export const getCountries = fetcher("/countries");
export const getDisabilities = fetcher("/disabilities");
export const getDisabilitiesLearningDifficulties = fetcher(
  "/disabilities-learning-difficulties"
);
export const getEmploymentIntensities = fetcher("/employment-intensities");
export const getEmploymentLengths = fetcher("/employment-lengths");
export const getEmploymentStatuses = fetcher("/employment-statuses");
export const getEthnicities = fetcher("/ethnicities");
export const getGenders = fetcher("/genders");
export const getHouseholdSituations = fetcher("/household-situations");
export const getLearningDifficulties = fetcher("/learning-difficulties");
export const getNationalities = fetcher("/nationalities");
export const getPriorAttainmentLevels = fetcher("/prior-attainment-levels");
export const getQualifications = fetcher("/qualifications");
export const getQualification = fetcher("/qualification");
export const getSchools = fetcher("/schools");
export const getStatements = (id) => fetcher(`/statements/${id}`)();
export const getTitles = fetcher("/titles");
export const getUnemployedLengths = fetcher("/unemployment-lengths");
